import React from 'react'
import { BorderLinearProgress } from './BorderLinearProgress'

//Componente para mostrar el porcentaje de subida de archivos
//TotalSize es el % de subida de archivos
const PdfsSizeBar = ({totalSize}: {totalSize: number}) => {
  return (
    <>
      {/* Parte del componente que tiene la barra de porcentaje */}
      <div className='my-4 relative w-full'>
      <BorderLinearProgress variant="determinate" value={parseInt(totalSize.toFixed(2))} sx={{height:"25px"}} />
      <p 
        className={`absolute top-0 text-center font-bold w-full h-fit ${parseInt(totalSize.toFixed(2)) > 100 && "bg-red-700 rounded"}`}
        style={{color: `${totalSize > 100 ? "white" : "black"}`}}>
        {`${totalSize.toFixed(2)}% usado`}
      </p>
    </div>

    {/* Indicaciones y error cuando se suben mas de 10MB*/}
    {totalSize > 100 
      ? <h4 className='error-message font-bold text-center mb-2'>Tus archivos han sobrepasado el limite de 10 MB, edita o elimina algunos.</h4> 
      : <p>* El tamaño de los archivos no debe superar los 10 MB</p>
    }
    
    </>
  )
}

export {PdfsSizeBar}